import React from 'react'
import {
  Control,
  CONTROL_STATUS,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import { ModalFormId } from '../../../../components/ModalForms'
import { StandardButtonVariant } from '../../../../components/Reusable/Buttons'
import {
  TabPanelButtonGroup,
  TabPanelNoteItem,
} from '../../../../components/Reusable/Tabs/TabNotes/styles'
import { AddConnectionModalToggle } from './AddConnectionModalToggle'

export const TabNote = ({
  control,
}: {
  control: Control.AsObject
}): JSX.Element => {
  const isNotApplicable = control.status === CONTROL_STATUS.NOTAPPLICABLE
  const addConnectionModalId = isNotApplicable
    ? ModalFormId.NA_INFO
    : ModalFormId.ADD_EVIDENCE_GENERATOR_CONNECTED_TAB
  return (
    <TabPanelNoteItem>
      <TabPanelButtonGroup>
        <AddConnectionModalToggle
          buttonVariant={StandardButtonVariant.PRIMARY}
          modalFormId={addConnectionModalId}
          control={control}
        />
      </TabPanelButtonGroup>
    </TabPanelNoteItem>
  )
}
